import { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import AUX from '../../../../hoc/Aux_';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMemberById,
  updateMember,
  getProjects,
  updateProjectMember,
} from '../../../../redux/MainAction';
import moment from 'moment';

const MemberEditModal = ({ open, onClose, m_id, filters }) => {
  const dispatch = useDispatch();
  const single = useSelector((state) => state?.Webtracker?.memberByID);
  const projList = useSelector((state) => state?.Webtracker?.projects);

  const [editData, setEditData] = useState({
    weeklyHours: '',
    rateHourly: '',
    role: '', // values can be 'EXECUTIVE-MANAGER', 'TEAM-MANAGER', 'PROJECT-MANAGER', 'EMPLOYEE'
    employmentType: '', // values can be 'FULL-TIME', 'PART-TIME'
    workModel: '', // values can be 'OFFICE-BASED', 'REMOTE', 'HYBRID'
    hiredAt: '',
    dateOfBirth: '',
    maritalStatus: '', // values can be 'SINGLE', 'MARRIED', 'DIVORCED', 'WIDOWED', 'I-PREFER-NOT-TO-SAY'
    address: '',
    phone: '',
    additionalInfo: '',
  });

  const [addProj, setAddProj] = useState({});

  const onChangeProj = (e, projectId) => {
    const { name, value } = e.target;
    setAddProj((prev) => ({
      ...prev,
      [projectId]: {
        ...prev[projectId],
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    if (m_id) getList();
  }, [m_id]);

  const getList = () => {
    var data = {
      id: m_id,
    };
    dispatch(getMemberById(data));
  };

  useEffect(() => {
    setEditData({
      weeklyHours: parseFloat(single?.userEmployeeRelation?.weeklyHours || 0),
      rateHourly: parseFloat(single?.userEmployeeRelation?.rateHourly || 0),
      role: single?.userEmployeeRelation?.role,
      employmentType: single?.userEmployeeRelation?.employmentType,
      workModel: single?.userEmployeeRelation?.workModel || 'OFFICE-BASED',
      hiredAt: moment(single?.userEmployeeRelation?.hiredAt).format(
        'YYYY-MM-DD'
      ),
      dateOfBirth: moment(single?.userEmployeeRelation?.dateOfBirth).format(
        'YYYY-MM-DD'
      ),
      maritalStatus: single?.userEmployeeRelation?.maritalStatus || 'SINGLE',
      address: single?.userEmployeeRelation?.address,
      phone: single?.userEmployeeRelation?.phone || 0,
      additionalInfo: single?.userEmployeeRelation?.additionalInfo,
    });
  }, [single]);

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const onSaveHandle = (e) => {
    e.preventDefault();

    const payload = {
      id: m_id,
    };

    if (editData?.editData?.role !== 'OWNER') {
      payload.role = editData?.role;
    }
    if (editData?.weeklyHours !== '') {
      payload.weeklyHours = editData?.weeklyHours;
    }
    if (editData?.rateHourly !== '') {
      payload.rateHourly = editData?.rateHourly;
    }
    if (editData?.employmentType !== '' && editData?.employmentType !== null) {
      payload.employmentType = editData?.employmentType;
    }
    if (editData?.workModel !== '') {
      payload.workModel = editData?.workModel;
    }
    if (editData?.hiredAt !== '' && editData?.hiredAt !== 'Invalid date') {
      payload.hiredAt = editData?.hiredAt;
    }
    if (
      editData?.dateOfBirth !== '' &&
      editData?.dateOfBirth !== 'Invalid date'
    ) {
      payload.dateOfBirth = editData?.dateOfBirth;
    }
    if (editData?.maritalStatus !== '') {
      payload.maritalStatus = editData?.maritalStatus;
    }
    if (editData?.address !== '' && editData?.address !== null) {
      payload.address = editData?.address;
    }
    if (editData?.additionalInfo !== '' && editData?.additionalInfo !== null) {
      payload.additionalInfo = editData?.additionalInfo;
    }

    dispatch(updateMember(payload, filters));
    onClose();
  };

  const onSaveProject = (e, projectMemberId, memberId) => {
    e.preventDefault();

    const projectData = addProj[projectMemberId] || {};

    const payload = {
      projectMemberId,
      hourlyRateType: projectData.hourlyRateType || 'MEMBER-RATE',
      ...(+projectData.hourlyRate
        ? { hourlyRate: +projectData.hourlyRate }
        : {}),
      ...(+projectData.weeklyLimitPerMember
        ? { weeklyLimitPerMember: +projectData.weeklyLimitPerMember }
        : {}),

      screenshotMode: projectData.screenshotMode || 'SCREENSHOT',
    };

    dispatch(updateProjectMember(payload));
    dispatch(getMemberById({ id: memberId }));
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div
            className={`overlay ${open ? 'open' : ''}`}
            id="myNav"
            style={{ ...(open ? { width: '50%' } : {}) }}
          >
            {/* <a href="javascript:void(0)" className="closebtn" >&times;</a> */}
            <div className="overlay-content">
              <div className="edit_member_head">
                <span className="edit_member_Icon text-uppercase">
                  {single?.firstName?.charAt(0)} {single?.lastName?.charAt(0)}
                </span>
                <div className="d-flex flex-column">
                  <span className="font-14">
                    {single?.firstName} {single?.lastName}
                  </span>
                  <span className="font-14">
                    Member since{' '}
                    {moment(single?.createdAt).format('MMM Do YYYY')}
                  </span>
                </div>
              </div>
              <ul
                className=" nav nav-tabs nav-tabs-custom edit_tab nav-justified"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#project"
                    role="tab"
                  >
                    <span className="d-none d-md-block">General</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-home-variant h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#properties"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Personal Info</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-email h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#members"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Projects</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-account h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#overview"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Billing</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-account h5"></i>
                    </span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#holy_day"
                    role="tab"
                  >
                    <span className="d-none d-md-block">Holidays</span>
                    <span className="d-block d-md-none">
                      <i className="mdi mdi-account h5"></i>
                    </span>
                  </a>
                </li>
              </ul>

              <div
                className="tab-content overflow-auto mx-4"
                style={{ height: 'calc(100vh - 333px)' }}
              >
                <div
                  className="tab-pane active px-3"
                  id="project"
                  role="tabpanel"
                >
                  <div className="mt-2">
                    <div className="d-flex col-12">
                      {/* <div className="form-group col-6">
                        <label for="limit " className="font-14 ">
                          Member type
                        </label>
                        <input
                          type="text"
                          id="limit"
                          name="role"
                          value={editData?.role}
                          className="form-control"
                        />
                      </div> */}
                      <div className="form-group col-6">
                        <label for="limit " className="font-14 ">
                          Member type
                        </label>
                        <div className="">
                          <select
                            className="form-control"
                            value={editData?.role}
                            name="role"
                            disabled={editData?.role === 'OWNER' ? true : false}
                            onChange={onHandleChange}
                          >
                            <option value="EXECUTIVE-MANAGER">
                              Executive Manager
                            </option>
                            <option value="TEAM-MANAGER">Team Manager</option>
                            <option value="PROJECT-MANAGER">
                              Project Manager
                            </option>
                            <option value="EMPLOYEE">Employee</option>
                            <option value="OWNER">Owner</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group col-6">
                        <label for="rate" className="font-14 ">
                          User weekly limit
                        </label>
                        <input
                          type="number"
                          name="weeklyHours"
                          className="form-control"
                          value={editData?.weeklyHours}
                          onChange={onHandleChange}
                        />
                      </div>
                    </div>
                    <div className="d-flex col-12">
                      <div className="form-group col-6">
                        <label for="limit " className="font-14 ">
                          Employment type
                        </label>
                        <div className="">
                          <select
                            className="form-control"
                            value={editData?.employmentType}
                            name="employmentType"
                            onChange={onHandleChange}
                          >
                            <option value="PART-TIME">Part Time</option>
                            <option value="FULL-TIME">Full Time</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group col-6">
                        <label for="rate" className="font-14 ">
                          Work model
                        </label>
                        <div className="">
                          <select
                            className="form-control"
                            value={editData?.workModel}
                            name="workModel"
                            onChange={onHandleChange}
                          >
                            <option value="OFFICE-BASED">Office Based</option>
                            <option value="REMOTE">Remote</option>
                            <option value="HYBRID">Hybrid</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex col-12">
                      <div className="form-group col-6">
                        <label for="limit " className="font-14 ">
                          Hired
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="rate"
                          name="hiredAt"
                          value={editData?.hiredAt}
                          onChange={onHandleChange}
                        />
                      </div>
                      <div className="form-group col-6"></div>
                    </div>
                    {/* <div className='d-flex col-12'>
                            <div className="form-group col-6">
                                <label for="limit " className='font-14 '>Team</label>
                                <div className="">
                                    <select className="form-control">
                                        <option value="true">QA Team</option>
                                        <option value="false">Devloper TEam</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group col-6">
                                <label for="rate" className='font-14 '>Title</label>
                                <div className="">
                                    <select className="form-control">
                                        <option value="true">QA</option>
                                        <option value="false">Devloper</option>
                                        <option value="hb">Hybrid</option>
                                    </select>
                                </div>
                            </div>
                        </div> */}
                  </div>
                  {/* <div className="form-group">
                        <label>Notes</label>
                        <textarea type="text" className="form-control" rows={4} placeholder=""/>
                    </div> */}
                </div>
                <div className="tab-pane px-3" id="members" role="tabpanel">
                  <div className="d-flex col-12">
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap  table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>Hourly rate</th>
                          <th>Weekly limit</th>
                          <th>Screenshot mode</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {projList &&
                          (single?.projectMembers &&
                          single?.projectMembers?.length !== 0 ? (
                            single?.projectMembers?.map((prj) => {
                              return (
                                <tr key={prj.id}>
                                  <td>
                                    <div>{prj?.project?.name}</div>
                                  </td>
                                  <td>
                                    <div className="proj_assing">
                                      <select
                                        className="form-control font-14"
                                        name="hourlyRateType"
                                        defaultValue={prj?.hourlyRateType}
                                        value={addProj[prj?.id]?.hourlyRateType}
                                        onChange={(e) =>
                                          onChangeProj(e, prj?.id)
                                        }
                                      >
                                        <option value="CUSTOM-RATE">
                                          Custom Rate
                                        </option>
                                        <option value="MEMBER-RATE">
                                          Member Rate
                                        </option>
                                        <option value="PROJECT-RATE">
                                          Project Rate
                                        </option>
                                      </select>
                                      <input
                                        type="number"
                                        id="limit7"
                                        placeholder="0"
                                        className="form-control"
                                        name="hourlyRate"
                                        defaultValue={prj?.hourlyRate}
                                        value={addProj[prj?.id]?.hourlyRate}
                                        onChange={(e) =>
                                          onChangeProj(e, prj?.id)
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="proj_addBtn">
                                      <i className="fa fa-pencil addBtn_icon"></i>
                                      <input
                                        type="number"
                                        id="limit8"
                                        placeholder="0"
                                        name="weeklyLimitPerMember"
                                        defaultValue={prj?.weeklyLimitPerMember}
                                        value={
                                          addProj[prj?.id]?.weeklyLimitPerMember
                                        }
                                        onChange={(e) =>
                                          onChangeProj(e, prj?.id)
                                        }
                                        className="form-control"
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div style={{ width: '150px' }}>
                                      <select
                                        className="form-control font-14"
                                        name="screenshotMode"
                                        defaultValue={prj?.screenshotMode}
                                        value={addProj[prj?.id]?.screenshotMode}
                                        onChange={(e) =>
                                          onChangeProj(e, prj?.id)
                                        }
                                      >
                                        <option value="SCREENSHOT">
                                          Screenshot
                                        </option>
                                        <option value="NO-SCREENSHOT">
                                          No Screenshot
                                        </option>
                                        <option value="BACKGROUND">
                                          Background
                                        </option>
                                        <option value="BLURRED-SCREENSHOT">
                                          Blurred Screenshot
                                        </option>
                                      </select>
                                    </div>
                                  </td>
                                  <td>
                                    <Button
                                      size="sm"
                                      outline
                                      color="primary"
                                      onClick={(e) =>
                                        onSaveProject(
                                          e,
                                          prj?.id,
                                          prj?.employeeId
                                        )
                                      }
                                    >
                                      Update
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={5} className="text-center">
                                No project assigned
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="tab-pane px-3" id="properties" role="tabpanel">
                  <div className="mt-2">
                    <div className="d-flex col-12">
                      <div className="form-group col-6">
                        <label for="limit2 " className="font-14 ">
                          Birthday
                        </label>
                        <div>
                          <input
                            type="date"
                            id="limit2"
                            className="form-control"
                            name="dateOfBirth"
                            value={editData?.dateOfBirth}
                            onChange={onHandleChange}
                          />
                        </div>
                      </div>
                      <div className="form-group col-6">
                        <label for="rate" className="font-14 ">
                          Marital status
                        </label>
                        <div className="">
                          <select className="form-control">
                            <option value="true">Single</option>
                            <option value="false">Married</option>
                            <option value="hb">Divorced</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex col-12">
                      <div className="form-group col-6">
                        <label for="limit3 " className="font-14 ">
                          Address
                        </label>
                        <input
                          type="text"
                          id="limit3"
                          className="form-control"
                          name="address"
                          value={editData?.address}
                          onChange={onHandleChange}
                        />
                      </div>
                      <div className="form-group col-6">
                        <label for="limit5 " className="font-14 ">
                          Phone
                        </label>
                        <input
                          type="number"
                          id="limit5"
                          className="form-control"
                          name="phone"
                          value={editData?.phone}
                          onChange={onHandleChange}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="col-12">
                        <label>Additional info</label>
                        <textarea
                          type="text"
                          className="form-control"
                          rows={4}
                          placeholder=""
                          name="additionalInfo"
                          value={editData?.additionalInfo}
                          onChange={onHandleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane px-3" id="overview" role="tabpanel">
                  <div className="mt-2">
                    <div className="d-flex col-12">
                      <div className="form-group col-6">
                        <label for="limit3 " className="font-14 ">
                          Hourly rate
                        </label>
                        <input
                          type="text"
                          id="limit3"
                          className="form-control"
                          name="rateHourly"
                          value={editData?.rateHourly}
                          onChange={onHandleChange}
                        />
                      </div>
                      <div className="form-group col-6"></div>
                    </div>
                  </div>
                </div>
                <div className="tab-pane px-3" id="holy_day" role="tabpanel">
                  <div className="m-2">
                    <div className="d-flex col-12">
                      <table
                        id="datatable"
                        className="table dt-responsive nowrap  table-vertical"
                        width="100%"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Date</th>
                            <th>Day Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <input type="checkbox" />
                            </td>
                            <td>New Year</td>
                            <td>Jan 01</td>
                            <td>Non Working</td>
                          </tr>
                          {/* Add other rows as needed */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-flex justify-content-end"
                style={{ margin: '10px 38px', gap: '10px' }}
              >
                <Button className="" onClick={onClose} size="sm">
                  Close
                </Button>
                <Button
                  outline
                  size="sm"
                  color="primary"
                  onClick={onSaveHandle}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default MemberEditModal;
